import {
  type AvatarComponent,
  type Chain,
  type DisclaimerComponent,
  type Locale,
  RainbowKitProvider,
  type Theme,
} from '@rainbow-me/rainbowkit';
import { QueryClientProvider, type QueryClientProviderProps } from '@tanstack/react-query';
import React from 'react';
import { WagmiProvider, type WagmiProviderProps } from 'wagmi';

export declare const ModalSizeOptions: {
  readonly COMPACT: 'compact';
  readonly WIDE: 'wide';
};

export type ModalSizes = (typeof ModalSizeOptions)[keyof typeof ModalSizeOptions];

export interface RainbowKitProviderProps {
  initialChain?: Chain | number;
  id?: string;
  theme?: Theme | null;
  showRecentTransactions?: boolean;
  appInfo?: {
    appName?: string;
    learnMoreUrl?: string;
    disclaimer?: DisclaimerComponent;
  };
  coolMode?: boolean;
  avatar?: AvatarComponent;
  modalSize?: ModalSizes;
  locale?: Locale;
}

export interface Web3ProviderProps {
  children: React.ReactNode;
  wagmiConfig: WagmiProviderProps['config'];
  wagmiProps?: Omit<WagmiProviderProps, 'config'>;
  rainbowKitProps?: RainbowKitProviderProps;
  queryClient: QueryClientProviderProps['client'];
}

export function Web3Provider({ children, wagmiConfig, wagmiProps, rainbowKitProps, queryClient }: Web3ProviderProps) {
  return (
    <WagmiProvider config={wagmiConfig} {...wagmiProps}>
      <QueryClientProvider client={queryClient}>
        <RainbowKitProvider {...rainbowKitProps}>{children}</RainbowKitProvider>
      </QueryClientProvider>
    </WagmiProvider>
  );
}
